import { FileServiceError } from "./FileServiceError";

export class FileServiceUnsupportedFileError extends FileServiceError {
  readonly fileExtension?: string;

  constructor(message: string, fileExtension?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "FileServiceUnsupportedFileError";
    this.fileExtension = fileExtension;
  }
}
